import TopBar from "./TopBar";

export { default as Tab } from "./Tab";
export { default as TabMenu } from "./TabMenu";

export default TopBar;



// WEBPACK FOOTER //
// ./src/components/TopBar/index.js